// js
import React from 'react';
import PropTypes from 'prop-types';
import { FormattedNumber } from 'react-intl';
import FormattedGB from '../../common/FormattedGB';
import RollUpOverviewStatPPTX from './RollUpOverviewStatPPTX';
import RollUpOverviewChartPPTX from './RollUpOverviewChartPPTX';


const RollUpOverviewRowPPTX = ({ title, configuredItems, dataRequired, percentIndexed, dataIndexed, ciscoDataPerDay, nonCiscoDataPerDay, ciscoDataIndexed, nonCiscoDataIndexed, ciscoPercentIndexed, nonCiscoPercentIndexed, showPercentIndexed }) => {

  const percentIndexedChart = (
    <div className='col-md-3'>
      <div className='analytics-roll-up-overview-row-pptx__chart'>
        <RollUpOverviewChartPPTX percent={percentIndexed / 100} />
      </div>
    </div>
  );

  const percentIndexedLabel = (
    <div className='col-md-2'>
      <div className='analytics__roll-up-overview-row-pptx__chart-label'>
        <FormattedNumber value={percentIndexed / 100} style='percent' /> indexed
        (<FormattedGB value={dataIndexed} perDay />)
      </div>
    </div>
  );

  const rowWidths =
    showPercentIndexed ?
    [2, 5] :
    [6, 6];

  return (
    <div className='analytics__roll-up-overview-row-pptx'>
      <div className='row'>
        <div className={`col-md-${rowWidths[0]}`}>
          <h4 className='analytics__roll-up-overview-row-pptx__title'>
            {title}
          </h4>
        </div>
        <div className={`col-md-${rowWidths[1]}`}>
          <div className='analytics__roll-up-overview-row-pptx__stats'>
            <div className='row'>
              <div className='col-md-6'>
                <RollUpOverviewStatPPTX
                  label='Configured Items'
                  value={'' + configuredItems}
                />
              </div>
              <div className='col-md-6'>
                <RollUpOverviewStatPPTX
                  label='Total Required Data per Day'
                  value={`${dataRequired.toFixed(1)} GB/day`}
                />
              </div>
            </div>
            <div className='row analytics__roll-up-overview-row-pptx__cisco-split'>
              <div className='col-md-6'>
                <RollUpOverviewStatPPTX
                  label='Non Cisco'
                  value={`${nonCiscoDataPerDay.toFixed(1)} GB/day`}
                />
              </div>
              <div className='col-md-6'>
                <RollUpOverviewStatPPTX
                  label='Cisco Data'
                  value={`${ciscoDataPerDay.toFixed(1)} GB/day`}
                />
              </div>
            </div>
            <div className='row analytics__roll-up-overview-row-pptx__cisco-indexed'>
              <div className='col-md-6'>
                <RollUpOverviewStatPPTX
                  label={`Non Cisco indexed (${nonCiscoPercentIndexed}%)`}
                  value={`${nonCiscoDataIndexed.toFixed(1)} GB/day`}
                />
              </div>
              <div className='col-md-6'>
                <RollUpOverviewStatPPTX
                  label={`Cisco Data indexed (${ciscoPercentIndexed}%)`}
                  value={`${ciscoDataIndexed.toFixed(1)} GB/day`}
                />
              </div>
            </div>
          </div>
        </div>
        {showPercentIndexed && percentIndexedChart}
        {showPercentIndexed && percentIndexedLabel}
      </div>
    </div>
  );
};

RollUpOverviewRowPPTX.propTypes = {
  title: PropTypes.string.isRequired,
  configuredItems: PropTypes.number.isRequired,
  dataRequired: PropTypes.number.isRequired,
  percentIndexed: PropTypes.number.isRequired,
  dataIndexed: PropTypes.number.isRequired,
  ciscoDataPerDay: PropTypes.number,
  nonCiscoDataPerDay: PropTypes.number,
  ciscoDataIndexed: PropTypes.number,
  nonCiscoDataIndexed: PropTypes.number,
  ciscoPercentIndexed: PropTypes.number,
  nonCiscoPercentIndexed: PropTypes.number,
  showPercentIndexed: PropTypes.bool.isRequired
};

RollUpOverviewRowPPTX.defaultProps = {
  ciscoDataPerDay: 0,
  nonCiscoDataPerDay: 0,
  ciscoDataIndexed: 0,
  nonCiscoDataIndexed: 0,
  ciscoPercentIndexed: 0,
  nonCiscoPercentIndexed: 0
};

export default RollUpOverviewRowPPTX;



// WEBPACK FOOTER //
// ./src/components/analytics/pptx/RollUpOverviewRowPPTX.js